module.exports = __webpack_public_path__ + "img/ym.d5bdcd96.jpg";